import { ISelectBox } from 'src/api/types/base-types';

export const positionType: ISelectBox[] = [
    { label: 'Board member', value: 'board member' },
    { label: 'Management team', value: 'management team' },
];
